import { useCallback, useContext, useEffect } from 'react';
import { AppContext } from 'providers/AppProvider';
import { ENTITY_TYPE, FLOW_TYPE, FLOW_TYPE_TO_NUMBER, HERO_URL_AV, RENEW_PREFIX } from 'consts';
import { FinishPageTranslationKeys } from './finish.helpers';
import { LINKS, LINKS_AV, LINKS_ES_MV } from './finish.consts';

export type FinishPageProps = Readonly<ReturnType<typeof useFinish>>;

export function useFinish() {
	const ctx = useContext(AppContext);
	const { config, entityType, fetchRelations, flowType, http, state, t } = ctx;
	const { agreementProcessId, portfolioId } = state.context.processInfo || {};
	const individual = entityType === ENTITY_TYPE.INDIVIDUAL;
	const baseFlowType = flowType.replace(RENEW_PREFIX, '').toUpperCase();
	const riskRenewalFlowType = (FLOW_TYPE_TO_NUMBER as any)[baseFlowType];
	const links = FLOW_TYPE.ES_MV === flowType ? LINKS_ES_MV : LINKS[entityType];
	const isAV = FLOW_TYPE.AV === flowType;
	const showTitle = isAV ? false : individual && (flowType === FLOW_TYPE.MV || flowType === FLOW_TYPE.RR_MV);
	const keys = FinishPageTranslationKeys(entityType, flowType, portfolioId);

	const buttonAction = useCallback(() => {
		window.location.href = isAV ? HERO_URL_AV : LINKS_AV.login_to_online_banking(config.APP_ENV);
	}, [config.APP_ENV, isAV]);

	useEffect(() => {
		if (FLOW_TYPE.RR_EB === flowType || FLOW_TYPE.RR_ER === flowType || FLOW_TYPE.RR_MV === flowType) {
			http
				.post(
					config.API.completeRiskQRenewalProcess,
					{ agreementProcessId, riskRenewalFlowType },
					t('loading_label', 'finish')
				)
				.then(fetchRelations);
		}
	}, [agreementProcessId, riskRenewalFlowType, flowType]); // eslint-disable-line

	return {
		...ctx,
		buttonAction,
		keys,
		links,
		showTitle
	};
}
